function param(name) {
  return window.location.href
    .split("?")[1]
    ?.split("&")
    ?.map((item) => item.split("="))
    ?.find((item) => item[0] === name)?.[1];
}

export { param };
